import { list } from "radash"
import React from "react"
import { Skeleton } from "../Skeleton"
import { Text } from "../Text"
import { Timeline } from "./Timeline"

type Props = {
  className?: string
  count?: number
}

export const TimelineSkeleton = ({ className, count = 2 }: Props) => {
  return (
    <Timeline className={className}>
      {list(1, count).map(i => (
        <Timeline.Item active key={i}>
          <Timeline.Item.Avatar>
            <Skeleton.Block />
          </Timeline.Item.Avatar>
          <Timeline.Item.Content>
            <Text.Body.Skeleton className="w-40" size="sm" />
          </Timeline.Item.Content>
        </Timeline.Item>
      ))}
    </Timeline>
  )
}
